export const terms = {
  lastUpdated: '25. Januar 2026',
  lastUpdatedLabel: 'Stand',
  
  meta: {
    title: 'Allgemeine Geschäftsbedingungen',
    description: 'Allgemeine Geschäftsbedingungen (AGB) für die Nutzung der Plattform Termin Teiler'
  },
  
  nav: {
    title: 'Inhaltsverzeichnis',
    scope: 'Geltungsbereich',
    subject: 'Gegenstand des Angebots',
    noContract: 'Kein Vertragsverhältnis',
    platformUse: 'Nutzung der Plattform',
    userObligations: 'Pflichten der Nutzer',
    liability: 'Haftung',
    availability: 'Verfügbarkeit',
    termination: 'Beendigung',
    dataProtection: 'Datenschutz',
    finalProvisions: 'Schlussbestimmungen',
  },
  
  sections: {
    scope: {
      title: '1. Geltungsbereich',
      content: `
        <p>(1) Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Online-Plattform Termin Teiler, betrieben von:</p>
        <p><strong>Feryal Catoglu<br/>
        TerminTeiler-Startpunkt57<br/>
        Sandstraße 26<br/>
        57072 Siegen<br/>
        Deutschland</strong></p>
        <p><strong>E-Mail:</strong> <a href="mailto:support@terminteiler.com">support@terminteiler.com</a></p>
        <p>(2) Die AGB gelten für alle Nutzer der Plattform in der aktuellen Test- und MVP-Phase.</p>
      `
    },
    
    subject: {
      title: '2. Gegenstand des Angebots',
      content: `
        <p>(1) TerminTeiler stellt eine digitale Plattform zur Verfügung, über die Nutzer freiwillig Informationen zu freien oder nicht wahrgenommenen Arztterminen teilen können.</p>
        <p>(2) TerminTeiler:</p>
        <ul>
          <li>vermittelt keine medizinischen Leistungen,</li>
          <li>bietet keine medizinische Beratung,</li>
          <li>garantiert keine Terminverfügbarkeit,</li>
          <li>steht in keiner vertraglichen Beziehung zu Arztpraxen oder medizinischen Einrichtungen.</li>
        </ul>
        <p>(3) Die Plattform dient ausschließlich der technischen Erprobung, Weiterentwicklung und dem Nutzerfeedback.</p>
      `
    },
    
    noContract: {
      title: '3. Kein Vertragsverhältnis mit Dritten',
      content: `
        <p>(1) Durch die Nutzung der Plattform kommt kein Vertragsverhältnis zwischen TerminTeiler und Ärzten, medizinischen Einrichtungen oder sonstigen Dritten zustande.</p>
        <p>(2) Jegliche Terminabsprachen erfolgen eigenverantwortlich und außerhalb des Verantwortungsbereichs von Termin Teiler.</p>
      `
    },
    
    platformUse: {
      title: '4. Nutzung der Plattform',
      content: `
        <p>(1) Die Nutzung der Plattform ist freiwillig und derzeit unentgeltlich.</p>
        <p>(2) Ein Anspruch auf bestimmte Funktionen, Inhalte oder eine dauerhafte Verfügbarkeit besteht nicht.</p>
        <p>(3) TerminTeiler behält sich vor, Funktionen jederzeit zu ändern, einzuschränken oder einzustellen.</p>
      `
    },
    
    userObligations: {
      title: '5. Pflichten der Nutzer',
      content: `
        <p>Nutzer verpflichten sich insbesondere:</p>
        <ul>
          <li>keine rechtswidrigen, irreführenden oder beleidigenden Inhalte einzustellen,</li>
          <li>keine personenbezogenen Daten Dritter ohne deren Einwilligung zu veröffentlichen,</li>
          <li>keine medizinischen Empfehlungen oder Diagnosen zu verbreiten,</li>
          <li>die Plattform nicht missbräuchlich zu nutzen.</li>
        </ul>
      `
    },
    
    liability: {
      title: '6. Haftung',
      content: `
        <p>(1) Termin Teiler haftet unbeschränkt bei:</p>
        <ul>
          <li>Vorsatz</li>
          <li>grober Fahrlässigkeit</li>
          <li>Verletzung von Leben, Körper oder Gesundheit</li>
        </ul>
        <p>(2) Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung auf den vorhersehbaren, typischerweise eintretenden Schaden begrenzt.</p>
        <p>(3) Eine Haftung für:</p>
        <ul>
          <li>ausgefallene oder verpasste Termine,</li>
          <li>gesundheitliche oder wirtschaftliche Folgeschäden,</li>
          <li>Inhalte von Nutzern</li>
        </ul>
        <p>ist ausgeschlossen, soweit gesetzlich zulässig.</p>
      `
    },
    
    availability: {
      title: '7. Verfügbarkeit',
      content: `
        <p>(1) TerminTeiler übernimmt keine Gewähr für eine jederzeitige Verfügbarkeit der Plattform.</p>
        <p>(2) Wartungen, technische Störungen oder Weiterentwicklungen können zu vorübergehenden Einschränkungen führen.</p>
      `
    },
    
    termination: {
      title: '8. Beendigung der Nutzung',
      content: `
        <p>(1) Nutzer können die Nutzung jederzeit einstellen.</p>
        <p>(2) TerminTeiler ist berechtigt, Nutzer bei Verstößen gegen diese AGB ganz oder teilweise von der Nutzung auszuschließen.</p>
      `
    },
    
    dataProtection: {
      title: '9. Datenschutz',
      content: `
        <p>Die Verarbeitung personenbezogener Daten erfolgt gemäß der <a href="/privacy-policy">Datenschutzerklärung</a> von Termin Teiler, die Bestandteil dieser AGB ist.</p>
      `
    },
    
    finalProvisions: {
      title: '10. Schlussbestimmungen',
      content: `
        <p>(1) Es gilt das Recht der Bundesrepublik Deutschland.</p>
        <p>(2) Sofern Nutzer Kaufleute sind, ist Gerichtsstand Siegen.</p>
        <p>(3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
      `
    }
  }
};
